<template>
	<div class="main" v-title data-title="零部件基本资料">
		<iHeader ref="loginIndex"></iHeader>
		<div class="flexRow justBetween barprebox mt25">
			<vnav></vnav>
			<div class="contR bgwhite">
				<div class="mt25 ml20">
					<div class="Ctitle">
						<h1 class="color1 font18 item1">账号绑定</h1>
						<div class="formW mt10">
							<div class="content_item">
								<span class="list_title">手机号：</span>
								<span class="list_status">{{mobile.num}}</span>
								<el-button type="primary" size="medium" class="fr" @click="mobilechange">{{mobile.text}}</el-button>
							</div>
							<el-divider></el-divider>
							<div class="content_item">
								<span class="list_title">微信号：</span>
								<span class="list_status">{{wx.num}}</span>
								<el-button type="primary" size="medium" class="fr" @click="wxchange">{{wx.text}}</el-button>
							</div>
							<el-divider></el-divider>
							<div class="content_item">
								<span class="list_title">QQ：</span>
								<span class="list_status">{{qq.num}}</span>
								<el-button type="primary" size="medium" class="fr" @click="qqchange">{{qq.text}}</el-button>
							</div>
							<!-- <el-divider></el-divider>
							<div class="content_item">
								<span class="list_title">邮箱：</span>
								<span class="list_status">已解绑</span>
								<el-button type="primary" size="medium" class="fr">解绑</el-button>
							</div> -->
						</div>
					</div>
				</div>
			</div>
		</div>
		<v-footer></v-footer>
		<el-dialog title="提示" :visible.sync="dialogVisible" width="80% !important" height="100%">
			<iframe :src="mobile.url" frameborder="0" width="100%" height="600px"></iframe>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="dialogVisible = false">确 定</el-button>
			</span>
		</el-dialog>
		<el-dialog title="提示" :visible.sync="wxdialogVisible" width="80% !important" height="100%">
			<iframe :src="wx.url" frameborder="0" width="100%" height="600px"></iframe>
			<span slot="footer" class="dialog-footer">
				<el-button @click="wxdialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="wxdialogVisible = false">确 定</el-button>
			</span>
		</el-dialog>

	</div>
</template>

<script>
	// 公共头部组件
	import iHeader from "@/components/indexheader"
	import vnav from "@/components/leftnav"
	import vFooter from "@/components/Footer"
	import "@/assets/cont-01.css";
	import Vue from 'vue';
	import axios from 'axios';
	Vue.prototype.$axios = axios;
	export default {
		components: {
			iHeader,
			vFooter,
			vnav,
		},
		data() {
			return {
				titleDec: "",
				mobile: '',
				qq: '',
				wx: '',
				dialogVisible: false, //弹出框
				wxdialogVisible: false, //弹出框
			}
		},
		created() {
			this.nump();
		},
		methods: {
			nump() {
				this.$postcn('partshome/accountbindinfo', {}, this).then((res) => {
					// console.log(res);
					if (res.status == 200 && res.data.code!=-4004) {
						this.mobile = res.data.mobile;
						this.qq = res.data.qq;
						this.wx = res.data.wx;

					} else if(res.data.code==-4004){
						this.$refs.loginIndex.handLogin(window.location.href)
					}else {
						this.$message({
							type: 'error',
							message: '数据错误'
						});
					}
				})
			},
			mobilechange() {
				this.dialogVisible = true;
				//window.location.href=this.mobile.url
			},
			wxchange() {
				this.wxdialogVisible = true;
				//window.location.href=this.wx.url
			},
			qqchange() {
				//this.qqdialogVisible = true;
				window.location.href = this.qq.url
			},
		}
	}
</script>

<style style="scoped">
	.item1 {
		display: inline-block;
	}

/* 	.formW {
		width: 600PX;
		margin-top: 40PX;

	} */

	.Ctitle {
		height: 35px;
		line-height: 35px;
		vertical-align: middle;
		margin-right: 20px;
		border-bottom: 1px solid #ccc;
	}

	.el-divider {
		margin: 12px 0px;
	}

	.w100 {
		width: 100px;
	}

	.list_title {
		-webkit-box-flex: 1;
		-ms-flex: 1;
		flex: 1;
		font-weight: 400;
		font-style: normal;
		font-size: 15px;
		color: #666;
		min-width: 100px;
	}

	.list_status {
		-webkit-box-flex: 7;
		-ms-flex: 7;
		flex: 7;
		color: #151519;
		font-weight: 700;
		font-size: 15px;
	}

	.content_item {
		display: -webkit-box;
		display: -ms-flexbox;
		display: flex;
		-webkit-box-pack: center;
		-ms-flex-pack: center;
		justify-content: center;
		-webkit-box-align: center;
		-ms-flex-align: center;
		align-items: center;
	}

	.el-dialogbig {
		width: 100% !important;
	}
</style>



// WEBPACK FOOTER //
// src/pages/people/nump.vue